import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from '@/pages/home/components/HeroSection';
import FeaturedAnime from '@/pages/home/components/FeaturedAnime';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import LatestUpdates from '@/pages/home/components/LatestUpdates';
import FAQSection from '@/pages/home/components/FAQSection';
import { faqs, siteInfo } from '@/mocks/anime';

export default function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const homeJsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: siteInfo.name,
      url: siteInfo.url,
      description: siteInfo.description,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.url,
      description: siteInfo.description,
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: `${siteInfo.name} - ${siteInfo.tagline}`,
      description: siteInfo.description,
      url: siteInfo.url,
      isPartOf: {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
      },
    },
    faqSchema,
  ];

  return (
    <>
      <SEOHead
        title={`${siteInfo.name} - ${siteInfo.tagline} - 动漫大全`}
        description={siteInfo.description}
        keywords="樱花动漫,手机动漫门户,动漫大全,移动动漫资源,动漫推荐,新番动漫,日本动漫,国产动漫"
        canonicalUrl={siteInfo.url}
        jsonLd={homeJsonLd}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedAnime />
          <CategoryGrid />
          <LatestUpdates />
          <FAQSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}